import { Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import shallow from 'zustand/shallow';
import { useStore } from '../../../context/store';
import { CellRenderInfo } from './RangePicker';
import { format } from '../helpers';
import { getSameComparitor, getFormat } from '../helpers';
import { ArrowNextFilled, ArrowPreviousFilled } from '@fluentui/react-icons';

export const CalendarCell = ({ info, date }: { info: CellRenderInfo; date: Date; }) => {
	type MarkerInfo = {
		end: boolean;
		start: boolean;
	};
	const { timelineMeta, resolution } = useStore(
		store => ({
			timelineMeta: store.timelineMeta,
			resolution: store.timeline.resolution,
		}),
		shallow
	);

	const { start, end } = useMemo<MarkerInfo>(() => {
		if (timelineMeta && resolution != null) {
			const isSame = getSameComparitor(resolution);
			return {
				start: isSame(timelineMeta.start, date),
				end: isSame(timelineMeta.end, date),
			};
		}
		return {
			start: false,
			end: false,
		};
	}, [date, resolution, timelineMeta]);

	const title = useMemo(() => {
		if (timelineMeta && (start || end)) {
			// TODO - localize
			let infoText: string;
			if (start && end) {
				infoText = 'starts and ends';
			} else if (start) {
				infoText = 'starts';
			} else if (end) {
				infoText = 'ends';
			}
			return `${timelineMeta.name} ${infoText} - ${format(date, getFormat(info, resolution))}`;
		}
	}, [date, end, info, resolution, start, timelineMeta]);

	return (
		<div className="ant-picker-cell-inner" title={title}>
			<Stack horizontal horizontalAlign="center" verticalAlign="center">
				{start && <StartMarker />} {info.originNode.props.children} {end && <EndMarker />}
			</Stack>
		</div>
	);
};

const StartMarker = () => {
	return (
		<div style={{ height: 15, width: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 15 }}>
			<ArrowPreviousFilled />
		</div>
	);
};

const EndMarker = () => {
	return (
		<div style={{ height: 15, width: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 15 }}>
			<ArrowNextFilled />
		</div>
	);
};